// searchWorker.js
import ClockWorker from '../workers/clock.worker'

const clockWorker = typeof window === 'object' && new ClockWorker()

export default clockWorker